import React from 'react'
import styled from '@emotion/styled'
import { useStaticQuery, graphql } from 'gatsby'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import { PointCard } from 'src/components/molecules/PointCard'
import { PointCardLayout } from 'src/components/molecules/PointCardLayout'
import HeadingBorder from 'src/components/atoms/HeadingBorder'

const points = [
  {
    imageName: 'touchpoint',
    title: 'タッチポイントが\nバラバラ',
    description:
      'ヘルプページ、問い合わせフォームなどタッチポイントがバラバラ。'
  },
  {
    imageName: 'one_way',
    title: '一方通行の\n発信に\nなりがち',
    description: '企業からの発信ばかりになり、ユーザーの反応が得られない。'
  },
  {
    imageName: 'exclusive',
    title: '一部の顧客にしか\n手が回っていない',
    description: 'ユーザー対応に工数がかかり、全てのお客様をカバーしきれない。'
  }
]

export const TopProblems = () => {
  const data = useStaticQuery(graphql`
    query {
      touchpoint: file(relativePath: { eq: "top/touchpoint.svg" }) {
        publicURL
      }
      one_way: file(relativePath: { eq: "top/one_way.svg" }) {
        publicURL
      }
      exclusive: file(relativePath: { eq: "top/exclusive.svg" }) {
        publicURL
      }
    }
  `)

  return (
    <Container>
      <ContentsWrapper>
        <HeadingBorder heading="PROBLEMS" />
        <HeadTitle as="h2">
          <Line>
            <NoLineBreak inlineIfMobile>お客様との</NoLineBreak>
            <NoLineBreak inlineIfMobile>コミュニケーションで</NoLineBreak>
          </Line>
          <Line>
            <NoLineBreak inlineIfMobile>こんな悩みを</NoLineBreak>
            <NoLineBreak inlineIfMobile>抱えていませんか？</NoLineBreak>
          </Line>
        </HeadTitle>
        <PointCardLayoutWrapper>
          <PointCardLayout skip2column>
            {points.map(point => {
              const { publicURL } = data[point.imageName]
              return (
                <PointCard
                  key={point.imageName}
                  {...point}
                  imageUrl={publicURL}
                />
              )
            })}
          </PointCardLayout>
        </PointCardLayoutWrapper>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.section`
  background-color: ${Styles.color.primary[200]};
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const Line = styled.span`
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    display: block;
  }
`

const PointCardLayoutWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    margin: 0;
  }
`
